<template>
  <div>
    <PopinBase :is-active="isActive" size="xs" @close="onClose" :z="500" :offset="0" @end="() => onSearch(true)" @back="emit('back')">
      <template #body>
        <div class="p-3 bg-white dark:bg-dark-950 overflow-hidden grid grid-cols-2 gap-1.5 md:gap-3" ref="$col">
          <div class="space-y-1.5 md:space-y-3" v-for="i in 2">
            <div
              class="bg-charcoal-100 rounded-xl relative text-light-950 cursor-pointer transition overflow-hidden"
              :class="[
                ratio === 'banner' ? 'h-16 md:h-24' : ''
              ]"
              v-for="gif in gifs.filter((g, j) => i === 1 ? j % 2 === 1 : j % 2 === 0)"
              @click="() => onSubmit(gif.media_formats.mediumgif.url)"
              :key="gif.id"
            >
              <img
              :src="gif.media_formats.tinygif.url"
              class=""
              :style="{
                height: (gif.media_formats.tinygif.dims[1] * (colWidth / gif.media_formats.tinygif.dims[0])) + 'px',
                width: colWidth
              }"
              :class="[
                ratio === 'banner' ? 'absolute top-0 left-0 w-full h-full object-cover' : 'w-full'
              ]"
              draggable="false"
              loading="lazy"
              v-if="isActive"
            >
            </div>
            <SkeletonBase class="!bg-charcoal-100 dark:!bg-dark-800 rounded-xl" :style="{ height: `${60 * k * i}px`}" v-for="k in 6" v-if="isLoading" />
          </div>
        </div>
      </template>
      <template #footer>
        <form @submit.prevent="() => onSearch(true)" class="flex items-center space-x-2 py-1 pl-0.5 pr-1.5">
          <InputBase color="transparent" v-model="search" :label="$t('components.InputTenor.label')" type="search" input-mode="search" class="!border-none" :placeholder="$t('components.InputTenor.placeholder')" ref="$search" />
          <ButtonBase color="slate" style-type="round" :is-loading="isLoading" type="submit" size="xs">
            <IconBase name="cute/search" :width="16" />
          </ButtonBase>
        </form>
      </template>
    </PopinBase>
  </div>
</template>

<script lang="ts" setup>
const props = withDefaults(defineProps<{
  isActive: boolean
  modelValue: string
  ratio?: 'none' | 'banner'
  searchSuffix?: string
  search?: string
}>(), {
  isActive: false,
  modelValue: '',
  search: '',
  searchSuffix: '',
  ratio: 'none'
})

const { isActive } = toRefs(props)

const emit = defineEmits<{
  (e: 'update:modelValue', v: string): void
  (e: 'close'): void
  (e: 'back'): void
}>()

const next = ref()
const isLoading = ref(false)
const search = ref('')

const $search = ref()
const $col = ref()
const { width } = useElementSize($col)
const colWidth = computed(() => (width.value - 6) / 2)

const gifs: Ref<{
  id: string
  media_formats: {
    tinygif: {
      url: string
      dims: [ number, number ]
    },
    mediumgif: {
      url: string
      dims: [ number, number ]
    }
  }
}[]> = ref([])

const onSearch = async (
  isNext?: boolean,
  isBlur = false
) => {
  if (isLoading.value) return
  
  isLoading.value = true
  if ($search.value && isBlur) $search.value.blur()

  try {
    if (!isNext) gifs.value = []

    const query = {
      key: 'AIzaSyBsqyboae1GMfs5z0zp6nw9qsEzpC4PpRs',
      media_filter: 'mediumgif,tinygif',
      contentfilter: 'low',
      limit: 20,
      pos: isNext ? next.value : '',
      locale: 'fr',
      ...((search.value || props.search) ? {
        q: search.value ? (search.value + ' ' + (isNext ? '' : props.searchSuffix)) : props.search,
      } : {
        country: 'FR'
      })
    } as any

    const response = await $fetch(
      (query.q ? 'https://tenor.googleapis.com/v2/search?' : 'https://tenor.googleapis.com/v2/featured?') + new URLSearchParams(query as any)
    )

    gifs.value = [...gifs.value, ...response.results.map((gif: any) => gif)]
    next.value = response.next
  } catch (e) {
    console.error(e)
  }

  isLoading.value = false
}

const onSubmit = (gif: string) => {
  emit('update:modelValue', gif)
  emit('close')
}

const onClose = () => {
  emit('close')
}

watch(isActive, () => {
  if (isActive.value) {
    onSearch()

    setTimeout(() => {
      if ($search.value) $search.value.focus()
    })
  }
})

watch(isActive, () => {
  if (isActive.value && gifs.value.length === 0) onSearch()

  if (!isActive.value) {
    search.value = ''
    gifs.value = []
  }
}, { immediate: true })

watchDebounced(search, () => {
  if (search.value.length > 2) onSearch()
}, { debounce: 500 })
</script>